import i18n from '@dms/i18n';

export const getTimeString = (time: string) => `${time} ${i18n.t('general.labels.hour')}`;
